export async function getDocument(axios, token) {
  try {
    const getDocumentURLURL = `ticket/document/${token}/`;

    return await axios.get(getDocumentURLURL);
  } catch (e) {
    if (e.response) {
      const errorCode = e.response.data.code;
      if (errorCode === 'submit_failed' || errorCode === 'unknown_error') {
        throw new Error('Form submission fail');
      }
    }
    throw new Error(e?.response?.data?.message);
  }
}
